import 'vue-draggable/polyfills'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import BootstrapVue from 'bootstrap-vue'
import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue2-timepicker/dist/VueTimepicker.css'
// import VueDragDrop from 'vue-drag-drop';
import VueDraggable from 'vue-draggable'
import i18n from './lang/i18n'
// import locale from 'element-ui/lib/locale/lang/ja'
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(BootstrapVue);
Vue.config.productionTip = false
// Vue.use(VueDragDrop);
Vue.use(require('vue-moment'));
Vue.use(VueDraggable)

try {
  let VueSocketIO = require('vue-socket.io')

  Vue.use(new VueSocketIO({
    debug: true,
    connection: process.env.VUE_APP_SOCKET_URL
  }))
} catch (error) {
  // console.log(error)
}

window.$i18n = i18n

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
